



























import { Component } from 'vue-property-decorator';
import FlyoutMenu from '@/views/layout/FlyoutMenu.vue';
import { getModule } from 'vuex-module-decorators';
import Routes from '@/util/Routes';
import CategoryStore from '@/stores/product/category.store';
import { CmsStore } from '@/stores/cms.store';
import { HeaderFragmentDto } from '@/api';
import CmsLink from '@/views/cms/snippet/CmsLink.vue';
import HeaderCmsMenu from '@/views/layout/HeaderCmsMenu.vue';
import { EventKey } from '@/util/EventKey';
import Vue from 'vue';

@Component({
  components: {HeaderCmsMenu, CmsLink, FlyoutMenu},
})
export default class HeaderBottomNavigation extends Vue {
  private categoryStore = getModule(CategoryStore, this.$store);
  private cmsStore = getModule(CmsStore, this.$store);
  private routes = Routes;
  private activeMenuIndex = -1;
  private readonly flyoutMenuId = -2;

  get cmsHeader(): HeaderFragmentDto | null {
    return this.cmsStore.header;
  }

  public async mounted(): Promise<void> {
    this.$events.$on(EventKey.MAIN_CANVAS_CLICK, this.handleCanvasClick);
    await this.categoryStore.fetchRootCategories();
  }

  public toggleMenu(menuIndex: number): void {
    if (this.isMenuActive(menuIndex)) {
      this.activeMenuIndex = -1;
    } else {
      this.activeMenuIndex = menuIndex;
    }
  }

  public isMenuActive(menuIndex: number): boolean {
    return this.activeMenuIndex === menuIndex;
  }

  private handleCanvasClick(): void {
    if (this.activeMenuIndex !== -1) {
      this.activeMenuIndex = -1;
    }
  }
}

interface HeaderLink {
  caption: string;
  to: string | object;
}
